module.exports = __webpack_public_path__ + "img/rogers-road-building-m.de1636cc.jpg";